module.exports = __webpack_public_path__ + "img/apple-safari.c09b1ba6.png";